export default __webpack_public_path__ + "static/media/ISKO CLASS 1 SYLLABUS.a08333d8.pdf";